const CompletedStepIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="8" cy="8" r="8" fill="#69B578" />
    <path
      d="M10.9855 5.77911C10.856 5.7828 10.7327 5.83934 10.6421 5.93644C10.513 6.07205 9.61202 7.04421 8.68801 8.04059C7.90837 8.88129 7.32147 9.51137 7.04916 9.80388L5.30412 8.40768C5.19876 8.32288 5.06532 8.28559 4.93343 8.30444C4.80193 8.32288 4.68253 8.3958 4.60214 8.50683C4.52176 8.61786 4.48665 8.75797 4.50459 8.89604C4.52293 9.03452 4.59239 9.15948 4.69852 9.24347L6.79628 10.9216C6.9949 11.0806 7.27507 11.0609 7.45183 10.8757C7.58099 10.7401 8.48193 9.76793 9.40594 8.77155C10.33 7.77516 11.2769 6.75465 11.3477 6.68039C11.496 6.53003 11.5408 6.29896 11.4608 6.09944C11.3804 5.89992 11.1919 5.77256 10.9855 5.77911Z"
      fill="white"
    />
  </svg>
);
export default CompletedStepIcon;
